import React, { ComponentProps } from "react";

import Header from "./components/Header";

const Title = ({ className, children, ...rest }: ComponentProps<"div">) => (
  <div className={className} {...rest}>
    {children}
  </div>
);

Title.Header = Header;

export default Title;
